import React from 'react';
import { BuildingIcon, TargetIcon, GlobeIcon, XIcon, EqualIcon } from 'lucide-react';
import { INTELLIGENCE_LAYERS, BRAND } from '../../data/dgpt';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
const ICONS = [BuildingIcon, TargetIcon, GlobeIcon];
export function IntelligenceLayers() {
  return <section aria-labelledby="layers-heading" className="border-b border-hairline-soft bg-surface" data-id="element-172" data-mp="n1hhmofkkaiy">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-173" data-mp="1arliio1dhw69">
        <SectionHeading eyebrow="Three Intelligence Layers" headingId="layers-heading" title="More Than Due Diligence." description="DiligenceGPT connects three intelligence layers that traditionally live in separate systems." data-id="element-174" data-mp="1fpdd5ptejwe5" />

        <ul className="mt-14 grid gap-4 lg:grid-cols-3" data-id="element-175" data-mp="1tompufieg8dd">
          {INTELLIGENCE_LAYERS.map((layer, index) => {
          const Icon = ICONS[index];
          return <Reveal key={layer.eyebrow} as="li" delay={index * 0.06} className="flex flex-col gap-5 rounded-2xl border border-hairline bg-panel p-6 transition-all duration-200 hover:-translate-y-0.5 hover:border-lime/30 sm:p-7" data-id="element-176" data-mp="25ay4sdy15cl7" data-mpi={index}>
                <div className="flex items-center justify-between" data-id="element-177" data-mp="2aaapot5cc9l5">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-lime/25 bg-lime/10" data-id="element-178" data-mp="2o1z0mt3uss0j">
                    <Icon className="h-[18px] w-[18px] text-lime" aria-hidden="true" data-id="element-179" data-mp="2j3nr6jhh0jiu" />
                  </span>
                  <span className="font-mono text-[11px] text-text-tertiary" data-id="element-180" data-mp="2xz3nkv5iwrie">L{index + 1}</span>
                </div>
                <div data-id="element-181" data-mp="2t1lf15vf4eax">
                  <h3 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-lime" data-id="element-182" data-mp="2sz7lx2katc60">
                    {layer.eyebrow}
                  </h3>
                  <p className="mt-2 text-xl font-semibold tracking-[-0.02em] text-text-primary" data-id="element-183" data-mp="yo2k83srv9tb">
                    {layer.title}
                  </p>
                </div>
                <ul className="flex flex-wrap gap-1.5" data-id="element-184" data-mp="1sc8gwtpe9fhu">
                  {layer.items.map(item => <li key={item} className="rounded-md border border-hairline-soft bg-elevated px-2.5 py-1.5 text-xs text-text-secondary" data-id="element-185" data-mp="1xbld4525nyx3">
                      {item}
                    </li>)}
                </ul>
              </Reveal>;
        })}
        </ul>

        <Reveal delay={0.12} className="mt-10 rounded-2xl border border-hairline bg-panel p-6 sm:p-8" data-id="element-186" data-mp="2b99lweiy7fls">
          <div className="flex flex-col items-center gap-4 text-center lg:flex-row lg:justify-center lg:gap-6" data-id="element-187" data-mp="2g4p057kvbdiq">
            {INTELLIGENCE_LAYERS.map((layer, index) => <React.Fragment key={layer.eyebrow} data-id="element-188" data-mp="2q2d66tnxc7g7" data-mpi={index}>
                {index > 0 ? <XIcon className="h-4 w-4 text-text-tertiary" aria-label="times" data-id="element-189" data-mp="2v0ep9elco6ro" /> : null}
                <span className="rounded-lg border border-hairline bg-elevated px-4 py-2.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-text-secondary" data-id="element-190" data-mp="jduo5iemlydd">
                  {layer.eyebrow}
                </span>
              </React.Fragment>)}
            <EqualIcon className="h-5 w-5 text-lime" aria-label="equals" data-id="element-191" data-mp="4fskl87lhcw4" />
            <span className="flex flex-col items-center lg:items-start" data-id="element-192" data-mp="122hstzsw4lqf">
              <span className="text-2xl font-semibold tracking-[-0.03em] text-text-primary" data-id="element-193" data-mp="124u5bxfvq3w3">
                {BRAND.product}
              </span>
              <span className="text-xs text-lime" data-id="element-194" data-mp="sc6d7fzugo3p">{BRAND.tagline}</span>
            </span>
          </div>
        </Reveal>
      </div>
    </section>;
}